import { render } from "./ArchiveProjectDetails.vue?vue&type=template&id=28d6de72&scoped=true"
import script from "./ArchiveProjectDetails.vue?vue&type=script&lang=js"
export * from "./ArchiveProjectDetails.vue?vue&type=script&lang=js"

import "./ArchiveProjectDetails.vue?vue&type=style&index=0&id=28d6de72&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d6de72"]])

export default __exports__